import axios from 'axios'
import store from '../store'
import router from '@/router'
import authentication from '@/utils/auth'
import Vue from 'vue'
const VueCookie = require('vue-cookie')
// Tell Vue to use the plugin
Vue.use(VueCookie)
// set baseURL
// const env = process.env.NODE_ENV || 'development'
// if (env === 'development') {
//   const baseURL = 'http://localhost:5000'
// } else {
//   const baseURL = 'http://crm.dci-1.com:8090'
// }
export const baseURL = (process.env.NODE_ENV && process.env.NODE_ENV === 'development') ? 'http://localhost:5000' : 'https://dkl-dsms.dci-one.de/backend'
export const websiteAuditBaseURL = (process.env.NODE_ENV && process.env.NODE_ENV === 'development') ? 'http://127.0.0.1:8000' : 'https://website-audit.dci-one.de'
export const hostURL = (process.env.NODE_ENV && process.env.NODE_ENV === 'development') ? 'http://localhost:8116' : 'https://dkl-dsms.dci-one.de'
// export const baseURL = 'http://localhost:5000' // dev baseURL
// export const baseURL = 'http://crm.dci-1.com:8090' // prod baseURL
// 创建axios实例
export const pathSeparator = (process.env.NODE_ENV && process.env.NODE_ENV === 'development') ? '\\' : '/'
export const crmURL = (process.env.NODE_ENV && process.env.NODE_ENV === 'development') ? 'http://localhost:9000' : 'https://crm.dci-1.com'
export const service = axios.create({
  baseURL: baseURL, // api 的 base_url
  timeout: 60000 // 请求超时时间
})

const cookie_csrftoken = Vue.cookie.get('csrftoken')

export function getUniqueKey() {
  const dateString = Date.now().toString(36);
  const randomness = Math.random().toString(36).substring(2);
  return dateString + randomness;
}

// request拦截器
service.interceptors.request.use(
  config => {
    try {
      if (store.getters.token) {
        // config.headers['Authorization'] = 'Bearer ' + authentication.acquireToken() // 让每个请求携带自定义token 请根据实际情况自行修改. Micrsoft Graph Authentication
        config.headers['Authorization'] = 'Token ' + store.getters.getToken // 让每个请求携带自定义token 请根据实际情况自行修改
      }
      config.headers['X-CSRFToken'] = cookie_csrftoken
      if (!config.url.includes('logout')) {
        config.requestKey = getUniqueKey()
        let data = {}
        if (config.data && config.data instanceof FormData) {
          config.data.forEach((value, key) => {
            data[key] = value
          })
        }
        Vue.prototype.$localStore.setItem(config.requestKey, {
          url: config.url,
          method: config.method,
          data: data,
          headers: config.headers
        })
      }
      return config
    } catch (e) {
      console.log(e)
      return Promise.reject(e)
    }
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

function cleanQuestionUrl(url) {
  if (url.startsWith('todos/v1/questions/')) {
    return url.split('?')[0]
  }
  return url
}

export function saveSuccessResponse(response) {
  Vue.prototype.$localStore.removeItem(response.config.requestKey)
  Vue.prototype.$localStore.setItem(cleanQuestionUrl(response.config.url), response.data)
}

export async function loadFailedResponse(error) {
  let val = 'offline'
  if (!error.config) return false
  if (error.config.method === 'get') {
    val = await Vue.prototype.$localStore.getItem(cleanQuestionUrl(error.config.url))
    Vue.prototype.$localStore.removeItem(error.config.requestKey)
  } else {
    let changeList = await Vue.prototype.$localStore.getItem('changeRequestsList')
    changeList = changeList || []
    changeList.push({requestKey: error.config.requestKey, created: Date.now()})
    Vue.prototype.$localStore.setItem('changeRequestsList', changeList)
    if (error.config.method === 'post') {
      const originalRequest = await Vue.prototype.$localStore.getItem(error.config.requestKey)
      val = originalRequest.data
    }
  }
  const init = { "status" : 200, headers: { "Content-Type": "application/json" }};
  const response =  new Response(JSON.stringify(val), init);
  response.data = val
  return response
}

service.interceptors.response.use(response => {
  saveSuccessResponse(response)
  if (Vue.cookie.get('onlineStatus') !== 'on') {
    Vue.cookie.set('onlineStatus', 'on')
    if (process.env.NODE_ENV && process.env.NODE_ENV === 'production') service.defaults.timeout = 30000
  }
  return response;
}, async error => {
  if ( error.response !== undefined) {
    Vue.prototype.$localStore.removeItem(error.config.requestKey)
    if (error.response.status === 401) {
      router.push({name: 'index', params: {externalErrors: ['Ihre Anmeldung ist abgelaufen. Bitten erneut anmelden']}})
    }
  } else if (!error.status) {
    if (Vue.cookie.get('onlineStatus') !== 'off') {
      Vue.cookie.set('onlineStatus', 'off')
      if (process.env.NODE_ENV && process.env.NODE_ENV === 'production') service.defaults.timeout = 1000
    }
    return loadFailedResponse(error)
  }
  return Promise.reject(error);
});

export function serviceRequest(config) {
  return service.request(config).catch(error => console.log(error))
}

// // response 拦截器
// service.interceptors.response.use(
//   response => {
//     /**
//      * code为非20000是抛错 可结合自己业务进行修改
//      */
//     const res = response.data
//     if (res.code !== 20000) {
//       Message({
//         message: res.message,
//         type: 'error',
//         duration: 5 * 1000
//       })
//
//       // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
//       if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
//         MessageBox.confirm(
//           '你已被登出，可以取消继续留在该页面，或者重新登录',
//           '确定登出',
//           {
//             confirmButtonText: '重新登录',
//             cancelButtonText: '取消',
//             type: 'warning'
//           }
//         ).then(() => {
//           store.dispatch('FedLogOut').then(() => {
//             location.reload() // 为了重新实例化vue-router对象 避免bug
//           })
//         })
//       }
//       return Promise.reject('error')
//     } else {
//       return response.data
//     }
//   },
//   error => {
//     console.log('err' + error) // for debug
//     Message({
//       message: error.message,
//       type: 'error',
//       duration: 5 * 1000
//     })
//     return Promise.reject(error)
//   }
// )

export default service
